import { render, staticRenderFns } from "./FormSignedDocument.vue?vue&type=template&id=05370b8b"
import script from "./FormSignedDocument.vue?vue&type=script&lang=js"
export * from "./FormSignedDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports